module.exports = __webpack_public_path__ + "static/media/beaverton.cd76e5d7.webp";